<template>
  <v-app id="password-form">
    <v-main>
      <v-container style="height: 100%; display: grid" :fluid="true">
        <v-row align="center" justify="center">
          <v-col col="12" sm="8" md="4">
            <v-card class="elevation-4 card--flex-toolbar">
              <v-row>
                <v-col xs12 class="text-center mt-6">
                  <v-avatar size="48" color="grey">
                    <v-icon size="20" dark>fa-solid fa-lock</v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
              <!--              <v-app-bar flat color="transparent">-->
              <!--                <v-row>-->
              <!--                  <v-col xs12 class="text-center mt-6">-->
              <!--                    <v-avatar color="grey">-->
              <!--                      <v-icon dark>lock</v-icon>-->
              <!--                    </v-avatar>-->
              <!--                  </v-col>-->
              <!--                </v-row>-->
              <!--              </v-app-bar>-->
              <v-card-text class="px-6 pb-0">
                <v-form ref="passwordForm" v-model="valid" lazy-validation>
                  <v-text-field
                    autocomplete="off"
                    prepend-icon="fa-solid fa-lock"
                    class="password-text-field"
                    label="Password"
                    v-model="password"
                    variant="underlined"
                    min="9"
                    hint="min 8 characters and one number"
                    persistent-hint
                    :append-inner-icon="
                      showPassword ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'
                    "
                    :type="showPassword ? 'text' : 'password'"
                    :rules="passwordRules"
                    @click:append-inner="
                      () => (this.showPassword = !showPassword)
                    "
                  >
                  </v-text-field>
                  <v-text-field
                    autocomplete="off"
                    prepend-icon="fa-solid fa-lock"
                    label="Confirm Password"
                    v-model="rePassword"
                    variant="underlined"
                    min="9"
                    class="password-text-field my-4"
                    :append-inner-icon="
                      showPassword ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'
                    "
                    :type="showPassword ? 'text' : 'password'"
                    :rules="rePasswordRules"
                    @click:append-inner="
                      () => (this.showPassword = !showPassword)
                    "
                  >
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="px-6 pb-4">
                <v-btn
                  variant="flat"
                  class="text-none text-white"
                  @click="setPasswordButton"
                  color="primary"
                  style="color: white !important; width: 100%"
                >
                  Set Password
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "password-form",
  data() {
    return {
      valid: true,
      password: "",
      rePassword: "",
      showPassword: false,
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length > 8 || "Password must be at least 9 characters",
        (v) => /\d/.test(v) || "Password must contain at least 1 digit",
      ],
      rePasswordRules: [(v) => v === this.password || "Passwords must match"],
    };
  },
  props: {
    source: String,
  },
  methods: {
    setPasswordButton() {
      if (this.$refs.passwordForm.validate()) {
        this.updatePassword();
      }

      // let valid = this.validatePassword();
      // if (valid === true) {
      //   console.log("valid...");
      //   this.updatePassword();
      // } else {
      //   // TODO: Show error via switch on valid value
      //   console.log("password not valid: " + valid);
      // }
    },
    validatePassword() {
      if (this.password !== this.rePassword) {
        return "mismatch";
      }

      if (this.password.length < 9) {
        return "length";
      }

      if (!/\d/.test(this.password)) {
        return "characters";
      }

      return true;
    },
    updatePassword() {
      this.$emit("didUpdatePassword", this.password);
    },
  },
  watch: {},
  created: function () {
    console.log("password-form: created");
  },
  computed: {
    ...mapGetters("auth", ["session", "isAuthing"]),
    ...mapGetters("user", ["me"]),
  },
};
</script>

<!-- styling for the component -->
<style scoped>
.password-text-field :deep(.v-field__append-inner .v-icon) {
  font-size: 20px;
}
</style>
